import * as React from 'react'
import {Link} from 'react-router-dom'
import {isAddItemsActive} from '../../../../feature-flags'
import SolvvyButton, {SOLVVY_ADD_REMOVE_ITEM} from '../../../_shared/SolvvyButton'

const ADD_ITEM_LABEL = 'Add Item'

interface AddItemsProps {
  isAddable: boolean
  onError: () => void
  linkState: {
    [key: string]: unknown
  }
  onLinkClick?: () => void
  shouldNotShow?: boolean
}

export const AddItemsNavButton: React.FC<AddItemsProps> = ({
  isAddable,
  onError,
  linkState,
  onLinkClick,
  shouldNotShow,
}) => {
  if (isAddItemsActive) {
    if (shouldNotShow) return null

    return isAddable ? (
      <li>
        <Link
          to={{
            pathname: '/categories',
            state: linkState,
          }}
          onClick={onLinkClick}
          data-test-id="add-items-link"
        >
          Add Item
        </Link>
      </li>
    ) : (
      <li>
        <button onClick={onError} data-test-id="add-items-not-addable">
          {ADD_ITEM_LABEL}
        </button>
      </li>
    )
  }

  return (
    <li>
      <SolvvyButton workflowId={SOLVVY_ADD_REMOVE_ITEM}>{ADD_ITEM_LABEL}</SolvvyButton>
    </li>
  )
}
